import { createSelector } from 'reselect';

const cardPointer = state => state.tenderCard;
const currencyPointer = state => state.dictionary.currency;

export default createSelector([cardPointer, currencyPointer], (tenderCard, currency) => {
  const { info } = tenderCard;
  let curren = currency.find(c => c.uid === (info.currency ? Number(info.currency.id) : null));
  if (!curren) {
    curren = currency.find(c => c.id === 12000);
  }
  return curren;
});
